import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {connect} from 'pwa-helpers';

import store from '../../store';

@customElement('model-select')
export class ModelSelect extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.values {
				display: flex;
				flex-direction: column;
				flex-flow: column;
			}

			.selectedValue {
				color: var(--color-text-widget-value);
				font-size: var(--font-size-widget-small);
				margin-left: auto;
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.models = state.productData.models;
		this.modelsTranslations = state.productData.modelTranslations;
	}
	render() {
		if (!this.models || this.models.length <= 1) return null;

		return html`
			<div>
				<div class="title">
					<trans-label key="LU_Type" context="D" default="Model"></trans-label>
				</div>
				<div class="values">
					${repeat(this.models,
							(model) => model.productModelId,
							(model) => html`
								<model-select-item .model=${model} .translations=${this.modelsTranslations}></model-select-item>
							`)}
				</div>
			</div>

		`;
	}
}
